import styled from "styled-components";

export const JBOptInReminderHeaderDefaultBox = styled.div`
    display: flex; 
    flex-direction: column; 
    align-items: center;
    background-image: linear-gradient(transparent,${props => props.theme.colors.backgroundMiddleDark} 95%, ${props => props.theme.colors.backgroundMiddleDark} 100%);
    
    height: 106px;
    width: 100%;
    justify-content: center;
`;


